import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: "",
  mapImageUrl: "",
  filterData: {},
  isSubmitted: false
};
export const zipInfoSlice = createSlice({
  name: "zipInfo",
  initialState,
  reducers: {
    updateZipCodeValue: (state, action) => {
      state.value = action.payload;
    },

    updateZipFilterData: (state, action) => {
      state.filterData = action.payload;
    },

    updateMapImageUrl: (state, action) => {
      state.mapImageUrl = action.payload;
    },

    updateIsZipSubmitted: (state, action) => {
      state.isSubmitted = action.payload;
    }
  }
});

export const {
  updateMapImageUrl,
  updateZipCodeValue,
  updateZipFilterData,
  updateIsZipSubmitted
} = zipInfoSlice.actions;
export default zipInfoSlice.reducer;
